module.exports = __webpack_public_path__ + "img/0Q3A6078_L_Black.cb3f6cff.jpg";